<template>
    
    <ul style=" list-style-type: none;padding: 0;">                                  
        <router-link to="/qui-sommes-nous"><li class="m-3 text-secondary">Qui Sommes nous</li></router-link>
        <router-link to="/contacter-nous"><li class="m-3 text-secondary" style="cursor: pointer;">Contactez-nous</li></router-link> 
        <a href="https://emploi.ha.com.tn/login_up.php" target="_blank"><li class="m-3 text-secondary" style="cursor: pointer;">HA recrute</li></a>  
    </ul>

</template>

<script>
export default ({
    name: "footer-HA"
})
</script>


